import React from "react";
import Reveal from "../shared/Reveal";

const STATS = [
  { value: "15+", label: "Years in Business", detail: "Est. 2010" },
  { value: "500+", label: "Projects Completed", detail: "Kitchens, baths & more" },
  { value: "MHIC#", label: "05-147079", detail: "Licensed & Insured" },
  { value: "20-mi", label: "Service Radius", detail: "Baltimore & surrounding" },
];

export default function StatRail() {
  return (
    <section className="bg-primary py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-0 lg:divide-x lg:divide-white/15">
          {STATS.map((stat, i) => (
            <Reveal
              key={stat.label}
              y={12}
              delay={i * 80}
              className="text-center lg:px-8 py-2"
            >
              <div className="font-heading text-3xl font-bold text-accent mb-1">{stat.value}</div>
              <div className="font-body text-sm font-semibold text-white">{stat.label}</div>
              <div className="font-body text-xs text-white/55 mt-0.5">{stat.detail}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}